// Copyright (c) StrangeBee 2023

import React, { ReactElement } from 'react';
import { TagProps } from 'antd/lib/tag';
import { CaseCustomField } from 'thehive-sdk';
import { CustomFieldTag } from '@Organisms/CustomFieldTag/CustomFieldTag';

import './DisplayCustomFields.scss';

interface DisplayCustomFieldsProps {
    customFields: CaseCustomField[];
    color?: TagProps['color'];
    onClick?: (customField: CaseCustomField) => void;
    forceDisplay?: boolean;
}

export const DisplayCustomFields = ({
    customFields,
    onClick,
    forceDisplay = false,
}: DisplayCustomFieldsProps): ReactElement => (
    <>
        {Array.isArray(customFields) &&
            customFields?.map((customField) =>
                customField?.value !== undefined || forceDisplay ? (
                    <CustomFieldTag
                        key={customField._id}
                        customField={customField}
                        onClick={(): void => onClick?.(customField)}
                    />
                ) : null,
            )}
    </>
);
